export * from './ProductDetail';
